import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
import { Search } from '@element-plus/icons-vue';
import { onMounted, reactive, ref, toRaw, toRef, watch } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import _ from 'lodash';
export default {
  __name: 'ContractDetailEdit',
  props: {
    title: {
      type: String,
      default: '编辑合同清单商品',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    detailSettlement: {
      type: Object
    }
  },
  emits: ['success', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const openHandler = () => {
      data.form = JSON.parse(JSON.stringify(props.detailSettlement));
    };
    const data = reactive({
      form: {},
      suppliers: [],
      role: {},
      userList: [],
      userShow: false,
      checkUser: [],
      areaCode: ""
    });
    const elLoading = ref(false);
    const close = () => {
      data.form = {};
      emits('update:visible', false);
    };
    const setPriceIncludingTax = () => {
      const exclude = Number(data.form.unitPriceExcludingTax);
      const vat = Number(data.form.vatRate);
      const include = (exclude + exclude * vat / 100).toFixed(6);
      data.form.unitPriceIncludingTax = Number(include);
    };
    const setPriceExcludingTax = () => {
      const include = Number(data.form.unitPriceIncludingTax);
      const vat = Number(data.form.vatRate);
      const exclude = (include / (1 + vat / 100)).toFixed(6);
      data.form.unitPriceExcludingTax = Number(exclude);
    };
    const handleSaveContract = () => {
      if (!data.form.productCategory) {
        ElMessage.error("请输入产品大类！");
        return;
      }
      if (!data.form.unit) {
        ElMessage.error("请输入报价单位！");
        return;
      }
      if (!data.form.unitPriceExcludingTax) {
        ElMessage.error("请输入不含税单价！");
        return;
      }
      if (!data.form.unitPriceIncludingTax) {
        ElMessage.error("请输入含税单价！");
        return;
      }
      if (!Number(data.form.unitPriceIncludingTax)) {
        ElMessage.error("请输入正确的含税单价！");
        return;
      }
      if (!Number(data.form.unitPriceExcludingTax)) {
        ElMessage.error("请输入正确的不含税单价！");
        return;
      }
      if (!Number(data.form.vatRate)) {
        ElMessage.error("请输入正确的税率！");
        return;
      }
      apis.updateSettlementById(data.form).then(res => {
        if (res.success) {
          ElMessage.success("添加成功!");
          emits("success");
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        close();
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onOpen: openHandler,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "40%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSaveContract
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("保存", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: props.detailSettlement,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "产品大类/类别",
            prop: "productCategory"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.productCategory,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.form.productCategory = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "产品小类/项目内容",
            prop: "projectContent"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.projectContent,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.form.projectContent = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "标准规格",
            prop: "standardSpecifications"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.standardSpecifications,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.form.standardSpecifications = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "报价单位",
            prop: "unit"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.unit,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.form.unit = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "不含税单价/元",
            prop: "unitPriceExcludingTax"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.unitPriceExcludingTax,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.form.unitPriceExcludingTax = $event),
              onBlur: setPriceIncludingTax
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "含税单价/元",
            prop: "unitPriceIncludingTax"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.unitPriceIncludingTax,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.form.unitPriceIncludingTax = $event),
              onBlur: setPriceExcludingTax
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "增值税率/%",
            prop: "unitPriceIncludingTax"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.vatRate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.form.vatRate = $event),
              onBlur: setPriceIncludingTax
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "技术标准",
            prop: "technicalStandard"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.technicalStandard,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.form.technicalStandard = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "供货服务标准",
            prop: "supplyServiceStandard"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.supplyServiceStandard,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.form.supplyServiceStandard = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "质保期",
            prop: "warrantyPeriod"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.warrantyPeriod,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.form.warrantyPeriod = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "物料类别",
            prop: "materialCategory"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.materialCategory,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.form.materialCategory = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预留1",
            prop: "fFiled1"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.fFiled1,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => data.form.fFiled1 = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预留2",
            prop: "fFiled2"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.fFiled2,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.form.fFiled2 = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remarks"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.remarks,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.form.remarks = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, elLoading.value]])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};